import { Modal } from '@marriott/mi-ui-library';
import { useEffect } from 'react';
import { useNavContext } from '../../../organisms/NavigationContainer';
import { StyledMyTripsModal, StyledMyTripsModalCloseButton } from './MyTripsModal.styles';

export const MyTripsModal = () => {
  const { isMyTripsModalOpen, setIsMyTripsModalOpen } = useNavContext();

  const setClosed = () => setIsMyTripsModalOpen(false);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setClosed();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <StyledMyTripsModal
      modalId="mytripsmodal"
      show={isMyTripsModalOpen}
      handleBlur={true}
      popupOpenState={isMyTripsModalOpen}
      onClose={setClosed}
      className="my-trips-modal"
      secondaryClassName="my-trips-modal-inner"
    >
      <Modal.Body className="my-trips-modal-body">
        <StyledMyTripsModalCloseButton className="icon-clear" onClick={setClosed}>
          <span className="sr-only">Close Dialog</span>
        </StyledMyTripsModalCloseButton>
        <iframe
          src="/resLookupOverlay.mi?overlay=true"
          title="resLookupOverlay"
          frameBorder="0"
          allowFullScreen={false}
          id="resLookupOverlayIframe"
          width="100%"
          data-dt-last-src="https://www.marriott.com/resLookupOverlay.mi?overlay=true"
          style={{ height: '500px' }}
        />
      </Modal.Body>
    </StyledMyTripsModal>
  );
};
